/* Auto generated file */
/* eslint-disable */
import { SVGSprite, type SVGSpriteProps } from '../svg/SVGBase';

const Playground = ({ color = 'primary', aspectRatio = '1130/173', ...rest}: SVGSpriteProps) =>
    <SVGSprite use="Playground" aspectRatio={aspectRatio} color={color} {...rest} />;

export { Playground, Playground as default };
